import icons from './icons.json';

export default icons;
